import { loadGroupTransactions } from './load-data.js'
import { showAgGridV1 } from './ag-grid-v1/index.js'
import { showAgGridV2 } from './ag-grid-v2/index.js'

// const GRID_VERSION = 'v1'
const GRID_VERSION = 'v2'

export const viewParams = {}

export async function updateView (context, needToLoadData = false) {
  if (needToLoadData) {
    const groupTransactionsResponse = await loadGroupTransactions(context)
    context.groupTransactions = groupTransactionsResponse
  }

  let gridApi = null

  if (GRID_VERSION === 'v1') {
    gridApi = showAgGridV1(context)
  } else {
    gridApi = showAgGridV2(context)
  }
  return gridApi
}
